<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { MDCRipple } from '@material/ripple/index';
  import { MDCDialog } from '@material/dialog';
  import { TS } from '../config/translation-keys.js';
  import APIClient from '../state-charts/api-client';
  import MerchantSelector from '../forms/MerchantSelector.svelte';
  import Dialog from '../lib/components/Dialog.svelte';
  import PhoneNumberField from '../forms/PhoneNumberField.svelte';
  import CheckBox from '../lib/components/CheckBox.svelte';
  import * as R from 'ramda';
  import session from '../lib/session';
  import Selector from '../lib/components/Selector.svelte';
  import { t9n, set_language } from '../lib/translate';
  import { capitalize_word, url_for } from '../lib/utils.js';
  import settings from '../config';
  import InputField from '../lib/components/InputField.svelte';
  import Validators from '../lib/validators';
  import { show_message } from '../lib/flash';
  import _ from 'lodash';

  // component options  ------------------------------------------------------ //

  export let data = {};

  // internal variables ------------------------------------------------------ //

  let login_email;
  let login_password;
  let forgotten_password_email;
  let forgotten_password_dialog;
  let forgotten_password_message_dialog;
  let resend_confirmation_email;
  let resend_confirmation_dialog;
  let resend_confirmation_message_dialog;
  let wait_api = false;
  let valid_private_code = false;
  let timer;
  let private_next = false;
  let public_next = false;

  let final_step = false;
  let show_private_merchant_selector = true;
  let show_country_selector = false;

  let app_link_ios = 'https://apps.apple.com/fi/app/workpilots2/id1477608018';
  let app_link_android =
    'https://play.google.com/store/apps/details?id=com.workpilots.workpilots';

  // internal variables for reg------------------------------------------------ //

  let dispatch = createEventDispatcher();

  let email = null;
  let password = null;
  let password_confirm = null;
  let merchant_uuid = null;
  let merchant_uuid_private = null;
  let language = null;
  let first_name = null;
  let last_name = null;
  let phone = null;
  let tou_accepted = false;
  let default_private_code = false;

  let private_items = [];

  let merchant_selector_items = [];
  let private_merchant_selector_items = [];
  let private_merchants = [];
  let language_selector_items = [];
  let country_selector_items = [];
  let unique_private = [{}];
  let unique_public = [{}];

  let show_private_merchant_code_field = false;
  let registration_disabled = true;
  let merchant_selector;
  let main_domain = url_for(settings);
  let merchant_logo_url = '/assets/login-logo.png';
  let merchant_name_value;
  let merchant_name_value_private;
  let select_private_merchant = "Private merchant selector";
  let merchant_description;

  let validators = {
    email: true,
    password: true,
    password_confirm: true,
    first_name: true,
    last_name: true,
    phone: true,
    merchant: true,
    merchant_private: true,
    language: true,
  };

  let input_errors = {
    email: null,
    password: null,
    password_confirm: null,
    first_name: null,
    last_name: null,
    merchant: null,
    merchant_private: null,
    language: null,
    phone: null
  };

  let email_field;
  let first_name_field;
  let last_name_field;
  let password_field;
  let password_confirm_field;
  let phone_field;
  let private_merchant_code;
  let initialized = false;
  let wait;

  // translated strings ------------------------------------------------------ //

  let welcome_title;
  let sign_in_title;
  let email_label;
  let password_label;
  let login_label;
  let forgot_password_label;
  let forgotten_password_title;
  let forgotten_password_dialog_title;
  let forgotten_password_message;
  let resend_confirmation_label;
  let resend_confirmation_title;
  let resend_confirmation_message;
  let send_button_label;
  let close_button_label;

  // translated strings registration ------------------------------------------------------ //

  let create_account_label;
  let language_label;
  let language_no_choice_text;
  let first_name_label;
  let last_name_label;
  let confirm_password_label;
  let register_label;
  let already_user_label;
  let tou;
  let tou_file;
  let tou_link;
  let tou_text;
  let registration_success_title;
  let type_text;
  let reg_form_ok;
  let link_to_registration;
  let link_to_login;
  let register_tooltip_private_merchant;
  let register_tooltip_public_merchant;
  let merchant_no_service_description;

  let private_id = 'private-registration-input';
  let is_invite = false;
  let running_email = false;

  // utility functions login ------------------------------------------------- //

  const translate_texts = language => {
    create_account_label = t9n(TS.REGISTER_LABEL_CREATE_ACCOUNT);
    welcome_title = t9n(TS.LOGIN_FORM_WELCOME);
    sign_in_title = t9n(TS.LOGIN_FORM_SIGN_IN);
    email_label = t9n(TS.LOGIN_LABEL_EMAIL);
    password_label = t9n(TS.LOGIN_LABEL_PASSWORD);
    login_label = t9n(TS.LOGIN_LABEL_LOGIN);
    forgot_password_label = t9n(TS.LOGIN_LABEL_FORGOT_PASSWORD);
    forgotten_password_title = t9n(TS.LOGIN_LABEL_RESET_PASSWORD);
    forgotten_password_dialog_title = t9n(TS.LOGIN_FORM_FORGOT_PASSWORD);
    forgotten_password_message = t9n(TS.LOGIN_LABEL_RESET_MESSAGE);
    resend_confirmation_label = t9n(TS.LOGIN_LABEL_RESEND_CONFIRMATION);
    resend_confirmation_message = t9n(TS.LOGIN_LABEL_RESEND_MESSAGE);
    resend_confirmation_title = t9n(TS.LOGIN_LABEL_RESEND_TITLE);
    send_button_label = t9n(TS.LOGIN_FORM_SEND);
    close_button_label = t9n(TS.LOGIN_FORM_CLOSE);
    language_label = t9n(TS.REGISTER_LABEL_LANGUAGE);
    language_no_choice_text = t9n(TS.REGISTER_LABEL_SELECT_LANGUAGE);
    first_name_label = t9n(TS.REGISTER_LABEL_FIRST_NAME);
    last_name_label = t9n(TS.REGISTER_LABEL_LAST_NAME);
    confirm_password_label = t9n(TS.REGISTER_LABEL_PASSWORD_CONFIRM);
    register_label = t9n(TS.REGISTER_LABEL_REGISTER);
    already_user_label = t9n(TS.REGISTER_LABEL_ALREADY);
    tou = t9n(TS.MENU_LABEL_TERMS);
    tou_file = `${
      merchant_uuid ? merchant_uuid : 'c8f9f74ee04e4ee0853fdcbd4475e8bd'
    }.html`;
    tou_link = `<a id="tou_show" href="${settings.api_host}/tou/merchant/${tou_file}" target="_blank">${tou}</a>`;

    tou_text = t9n(TS.REGISTER_LABEL_TOU, 'service', tou_link);
    registration_success_title = t9n(TS.REGISTER_LABEL_SUCCESS);
    type_text = t9n(TS.NATIVE_SELECT_START_TYPE_TEXT);
    reg_form_ok = t9n(TS.REG_FORM_OK);
    link_to_registration = t9n(TS.LOGINREG_LINK_TO_REGISTRATION);
    link_to_login = t9n(TS.LOGINREG_LINK_TO_LOGIN);
    register_tooltip_private_merchant = t9n(TS.REGISTER_TOOLTIP_PRIVATE_MERCHANT);
    register_tooltip_public_merchant = t9n(TS.REGISTER_TOOLTIP_PUBLIC_MERCHANT);

    merchant_no_service_description = t9n(TS.MERCHANT_NO_SERVICE_DESCRIPTION);
  };

  const mqls = [
    window.matchMedia('(max-width: 768px)'),
    window.matchMedia('(min-width: 769px) and (max-width: 1024px)'),
    window.matchMedia('(min-width: 1025px)'),
  ];

  const open_forgotten_password_dialog = e => {
    forgotten_password_dialog = new MDCDialog(
      document.querySelector('#forgotten-password-dialog')
    );

    forgotten_password_dialog.open();
  };

  const create_forgotten_password_message_dialog = () => {
    let target = document.querySelector('.dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'forgotten-password-message',
        title: forgotten_password_title,
        content: forgotten_password_message,
        buttons: [
          {
            label: 'OK',
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const handle_forgotten_password = async e => {
    let data = { email: forgotten_password_email };

    wait_api = true;
    return await APIClient.submit_forgotten_password(data, () => {
      forgotten_password_dialog.close();
      let dialog = create_forgotten_password_message_dialog();
      dialog.open();
      wait_api = false;
    });
  };

  const open_resend_confirmation_dialog = () => {
    resend_confirmation_dialog = new MDCDialog(
      document.querySelector('#resend-email-confirmation-dialog')
    );

    resend_confirmation_dialog.open();
  };

  const create_resend_confirmation_message_dialog = () => {
    let target = document.querySelector('.dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'resend-email-confirmation-message',
        title: resend_confirmation_title,
        content: resend_confirmation_message,
        buttons: [
          {
            label: 'OK',
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const handle_resend_confirmation = async () => {
    let data = { email: resend_confirmation_email };

    wait_api = true;
    return await APIClient.submit_resend_confirmation_email(data, () => {
      resend_confirmation_dialog.close();
      let dialog = create_resend_confirmation_message_dialog();
      dialog.open();
      wait_api = false;
    });
  };

  const handle_login = async () => {
    let data = {
      email: login_email,
      password: login_password,
      subdomain: $session.merchant_subdomain || null,
    };
    wait_api = true;

    try {
      await APIClient.submit_login(data);
    } catch (e) {
      console.log('error');
      wait_api = false;
    }
    wait_api = false;
  };

  const enter_event_listener = () => {
    document.addEventListener('keydown', async (event) => {
      if (event.key === 'Enter') {
        await handle_login();
      }
    });
  };

  const handle_tou_change = () => {
    tou_accepted = !tou_accepted;
    registration_disabled = !check_filled();
  };

  const check_filled = () => {
    const TRUE = R.equals(true);
    const checks = [
      !!merchant_uuid,
      !!language,
      !!email && !!validators.email,
      !!first_name && !!validators.first_name,
      !!last_name && !!validators.last_name,
      !!phone && !!validators.phone,
      !!password && !!validators.password,
      !!password_confirm && !!validators.password_confirm,
      !!tou_accepted,
    ];

    return R.all(TRUE)(checks);
  };

  // utility functions reg ---------------------------------------------------- //

  const registration_success_message = name => {
    return t9n(TS.REGISTER_MESSAGE_SUCCESS, capitalize_word(name));
  };

  const set_tou_file = merchant_uuid => {
    tou_file = `${
      merchant_uuid ? merchant_uuid : 'c8f9f74ee04e4ee0853fdcbd4475e8bd'
    }.html`;
    tou_link = `<a id="tou_show" href="${settings.api_host}/tou/merchant/${tou_file}" target="_blank">${tou}</a>`;

    let service = t9n(TS.MERCHANT_LABEL_SERVICE).toLowerCase();
    if (!!merchant_name_value_private) service = merchant_name_value_private;
    if (!!merchant_name_value) service = merchant_name_value;

    tou_text = t9n(TS.REGISTER_LABEL_TOU, service, tou_link);

    tou_accepted = false;
  };

  const handle_language_change = language => {
    set_language(language);
    registration_success_title = t9n(TS.REGISTER_LABEL_SUCCESS);
    reg_form_ok = t9n(TS.REG_FORM_OK);
  };

  const create_registration_message_dialog = () => {
    let target = document.querySelector('.registration-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'forgotten-password-message',
        title: registration_success_title,
        content: registration_success_message(first_name),
        buttons: [
          {
            label: reg_form_ok,
            action: () => {
              flip_to_login();
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const handle_register = async () => {

    if(!tou_accepted){
      show_message(t9n(TS.REGISTER_MESSAGE_ACCEPT_TOU), 'error');
    } else{
      let data = {
        email,
        first_name,
        last_name,
        language,
        password,
        password_confirm,
        phone,
      };

      if(!!merchant_uuid_private) data.merchant_uuid = merchant_uuid_private;
      if(!!merchant_uuid) data.merchant_uuid = merchant_uuid;

      wait_api = true;

      try{
        await APIClient.submit_registration(data).then(() => {
          let dialog = create_registration_message_dialog();
          dialog.open();
          wait_api = false;
        });
      } catch (e) {
        show_message(t9n(e.message), 'error');
        await validate_email(email);
        await validate_phone(phone);
        validate_password(password, password_confirm);
        validate_password_confirm(password_confirm, password);
        validate_first_name(first_name);
        validate_last_name(last_name);
        validate_merchant();
        validate_language();

      }


      // console.log('result', result);
    }

  };

  const check_is_private = id => {
    let merchant;
    if ($session.api_config) {
      merchant = $session.api_config.merchants.find(m => m.id === id);
    }
    if (merchant.service.private_service === true) {
      private_merchant_code = merchant.service.private_code;
      return true;
    } else {
      return false;
    }
  };

  const set_private_merchant = () => {
    private_merchant_code = data.private_code;
    default_private_code = true;
  };

  const flip_to_reg = (invite = false) => {
    document.querySelector('.flip-card-inner').classList.toggle('flip');
    let fix_background_size = document.querySelector('#login-page');
    fix_background_size.style.overflow = 'hidden';
    let front = document.querySelector('.flip-card-front');
    wait = setTimeout(() => {
      front.style.display = 'none'; // this is needed because of backface problems
      fix_background_size.style.overflow = 'auto';
    }, 500);
    show_private_merchant_selector = true;
    if (invite === true){
      open_rest_of_reg();
    }
  };

  const flip_to_login = () => {
    document.querySelector('.flip-card-front').style.display = 'block';
    let fix_background_size = document.querySelector('#login-page');
    fix_background_size.style.overflow = 'hidden';
    document.querySelector('.flip-card-inner').classList.toggle('flip');
    setTimeout(() => {
      fix_background_size.style.overflow = 'auto';
    }, 500);
    // final_step = false;
    // valid_private_code = false;
    // private_merchant_code = null;
    // show_private_merchant_selector = false;
    // show_country_selector = false;
    //
    // unique_public = [{}]
    // unique_private = [{}]

    // merchant_uuid_private = 'private';
    // value = 'private';
  };

  const set_subdomain = () => {
    if ($session.merchant_subdomain && $session.merchant && $session.branding) {
      merchant_uuid = $session.merchant.merchant_uuid;
      main_domain = $session.merchant_subdomain
        ? url_for(settings, $session.merchant_subdomain)
        : main_domain;
      merchant_logo_url = $session.branding
        ? main_domain + $session.branding.vars.logo_url
        : merchant_logo_url;
      set_tou_file(merchant_uuid);
      translate_texts();
    }
  };

  const validate_email = async email => {
    let result = await Validators.validate_email(email);
    validators.email = result.valid;
    input_errors.email = result.error;
  };

  const validate_password = (pw, pw_confirm) => {
    let result = Validators.validate_password(pw, pw_confirm);
    validators.password = result.valid;
    input_errors.password = result.error;
  };

  const validate_password_confirm = (pw_confirm, pw) => {
    let result = Validators.validate_password(pw_confirm, pw);
    validators.password_confirm = result.valid;
    input_errors.password_confirm = result.error;
  };

  const validate_first_name = name => {
    let result = Validators.validate_first_name(name);
    validators.first_name = result.valid;
    input_errors.first_name = result.error;
  };

  const validate_last_name = name => {
    let result = Validators.validate_last_name(name);
    validators.last_name = result.valid;
    input_errors.last_name = result.error;
  };

  const validate_merchant = () => {
    if(!!merchant_uuid){
      validators.merchant = true;
      input_errors.merchant = null;
    } else{
      validators.merchant = false;
      input_errors.merchant = t9n(TS.INVALID_INPUT);
    }
  }

  const validate_language = () => {
    if(!!language){
      validators.language = true;
      input_errors.language = null;
    } else{
      validators.language = false;
      input_errors.language = t9n(TS.INVALID_INPUT);
    }
  }

  const validate_phone = async phone_obj => {
    let result = await Validators.validate_phone(phone_obj);
    validators.phone = result.valid;
    input_errors.phone = result.error;
  };

  const check_inputs = () => {
    setTimeout(() => {
      registration_disabled = !check_filled();
    }, 500);
  };

  const open_private_selector = () => {
    document.querySelector(".container").style.setProperty('--translateValue', '0');
    document.querySelector('#help_line_for_pub_merch').style.display = 'none';

    merchant_uuid = null;
    merchant_name_value = null;
    public_next = false;
    unique_public = [{}]
  }

  const open_rest_of_reg = () => {
    document.querySelector(".container").style.setProperty('--translateValue', '-200%');
  }

  const open_country_selector = () => {
    document.querySelector(".container").style.setProperty('--translateValue', '-100%');
    document.querySelector('#help_line_for_private_merch').style.display = 'none';

    merchant_uuid_private = null;
    merchant_name_value_private = null;
    private_next = false;

    unique_private = [{}];
  }

  const handle_back = () => {
    if (!!merchant_uuid) {
      document.querySelector(".container").style.setProperty('--translateValue', '-100%');
    } else {
      document.querySelector(".container").style.setProperty('--translateValue', '0');
    }
  }

  // const reset_private = () => {
  //   if(valid_private_code){
  //     valid_private_code = false;
  //     private_merchant_code = null;
  //     show_private_merchant_code_field = true;
  //     merchant_uuid_private = 'private';
  //   }
  // }

  // initialization ----------------------------------------------------------- //

  const init_register_form = () => {
    new MDCRipple(document.querySelector('.mdc-button'));
    translate_texts();
    enter_event_listener();
    set_subdomain();
  };

  const validate_private_code = () => {
    private_next = false;
    if (valid_private_code && private_merchant_code === null) private_next = true;
    // if(merchant_uuid_private) private_next = true;
  }

  const validate_public_code = () => {
    public_next = false;
    if (merchant_uuid) public_next = true;
  }

  onMount(init_register_form);

  // reactive functions ------------------------------------------------------- //

  $: translate_texts();

  $: if (!!language) handle_language_change(language);

  $: if ($session.api_config && $session.api_config.supported_languages) {
    language_selector_items = Object.entries(
      $session.api_config.supported_languages
    ).map(lang => {
      return { val: lang[0], name: lang[1] };
    });
  }

  $: set_tou_file(merchant_uuid);
  $: set_tou_file(merchant_uuid_private);
  $: if(is_invite && merchant_name_value) set_tou_file(merchant_uuid);

  $: if (!!merchant_uuid) check_inputs();
  $: if (!!language) check_inputs();
  $: if (!!email) check_inputs();
  $: if (!!first_name) check_inputs();
  $: if (!!last_name) check_inputs();
  $: if (!!phone) check_inputs();
  $: if (!!password) check_inputs();
  $: if (!!password_confirm) check_inputs();
  $: if (tou_accepted || !tou_accepted) check_inputs();

  // $: if(merchant_uuid || language || email || first_name || last_name || phone || password || password_confirm || tou_accepted){
  //   setTimeout(() => { registration_disabled = !check_filled(); }, 500);
  // }

  $: {
    if (!initialized && data && data.email) {
      is_invite = true;
      if (data.private_service) {

        set_private_merchant();
        email = data.email;
        first_name = data && data.name ? data.name : null;
      } else {
        email = data.email;
        merchant_uuid = data && data.merchant_uuid ? data.merchant_uuid : null;
        first_name = data && data.name ? data.name : null;
      }
      flip_to_reg(true);
      initialized = true;
    }
  }

  $: set_subdomain($session);

  let previous_email = ''
  $: if (!!email && email !== previous_email){
    if(!running_email){
      running_email = true;
      previous_email = email
      setTimeout(async () => {
        await validate_email(email);
        running_email = false
      }, 1500);
    }
  }

  let running_password = false;
  $: if (!!password && password.length > 0){
    if(!running_password){
      running_password = true;
      let debounce_fun = _.debounce(async () => {
        validate_password(password, password_confirm);
        running_password = false;
      }, 1500);

      debounce_fun();
    }
  }

  let running_password_confirm = false;
  $: if (!!password_confirm && password_confirm.length > 0){
    if(!running_password_confirm){
      running_password_confirm = true;
      let debounce_fun = _.debounce(async () => {
        validate_password_confirm(password_confirm, password);
        running_password_confirm = false;
      }, 1500);

      debounce_fun();
    }
  }

  // $: if (!!password && password.length > 0){
  //   validate_password(password, password_confirm);
  // }

  // $: if (!!password_confirm && password_confirm.length > 0)
  //   validate_password_confirm(password_confirm, password);


  let running_first_name = false;
  $: if (!!first_name && first_name.length > 0){
    if(!running_first_name){
      running_first_name = true;
      let debounce_fun = _.debounce(async () => {
        validate_first_name(first_name);
        running_first_name = false;
      }, 1500);

      debounce_fun();
    }
  }



  // $: if (!!first_name && first_name.length > 0) validate_first_name(first_name);


  let running_last_name = false;
  $: if (!!last_name && last_name.length > 0){
    if(!running_last_name){
      running_last_name = true;
      let debounce_fun = _.debounce(async () => {
        validate_last_name(last_name);
        running_last_name = false;
      }, 1500);

      debounce_fun();
    }
  }


  // $: if (!!last_name && last_name.length > 0) validate_last_name(last_name);


  $: if(private_merchant_code) validate_private_code();
  $: if(valid_private_code) validate_private_code();
  $: if(!valid_private_code) validate_private_code();
  $: if(merchant_uuid) validate_public_code();

  $: if (merchant_uuid) {
    document.querySelector('#help_line_for_pub_merch').style.display = 'block';
    merchant_selector_items.forEach(item => {
      if (item.val === merchant_uuid) merchant_description = item.description
    })
  }

  $: if (merchant_name_value_private) {
    private_merchant_selector_items.forEach(item => {
      if (item.val === merchant_uuid_private) {
        if (item.description !== null) {
          merchant_description = item.description;
          document.querySelector('#help_line_for_private_merch').style.display = 'block';
        } else {
          merchant_description = merchant_no_service_description;
        }
      }
    })
  }

  // $: private_next = !(!private_merchant_code && valid_private_code);
  // $: merchant_name_value && set_tou_file(merchant_uuid);

</script>

<div class="flip-card">
  <div class="flip-card-inner">
    <div class="flip-card-front">

      <img src={merchant_logo_url} alt="service logo" class="logo fade-in" />

      <div style='height: auto; width: auto'>
        <div class="loginContainer mdc-elevation--z5">
        <h1 class="mdc-typography--headline2 welcome-padding">
          {welcome_title}
        </h1>

        <div class="margin-space" />

        <!-- Email field -->
        <InputField
          id="login-email"
          data_cy="login-email"
          type="email"
          label={email_label}
          leading_icon="email"
          name="login_email"
          width="350px"
          bind:value={login_email} />

        <!-- Password field -->
        <InputField
          id="login-password"
          data_cy="login-password"
          type="password"
          label={password_label}
          leading_icon="security"
          trailing_icon="password"
          name="login_password"
          width="350px"
          bind:value={login_password} />

        <!-- Forgot password link -->
        <button
          id="forgotten-password-opener"
          style="margin-top: 15px; margin-bottom: 15px"
          class="mdc-button2 mdc-dialog__button"
          on:click|stopPropagation|preventDefault={open_forgotten_password_dialog}>
          <span class="mdc-button__label">{forgot_password_label}</span>
        </button>

        <!-- Resend invitation 'button' -->
        <button
          id="resend-invitation"
          style="text-align: center"
          class="mdc-button2 mdc-dialog__button"
          on:click|preventDefault={open_resend_confirmation_dialog}>
          <span class="mdc-button__label">{resend_confirmation_label}</span>
        </button>

        <!-- Login button -->
        <div class="actionContainer">
          <!--{#if wait_api}-->
          <button
            style="position: unset; margin-top: 8px"
            data-cy="login"
            class="mdc-button mdc-button--raised"
            on:click|preventDefault={async () => { await handle_login() }}>
            {login_label}
          </button>
          <!--{:else}-->
          <!--  <button-->
          <!--    data-cy='login'-->
          <!--    class='mdc-button mdc-button&#45;&#45;raised'-->
          <!--    on:click|preventDefault={handle_login}>-->
          <!--    {login_label}-->
          <!--  </button>-->
          <!--{/if}-->
        </div>

        <div
          style="margin-top: 24px; height: 10px; border-top: #ad9999;
          border-top-style: solid; border-width: thin;" />
        <a
          class="flip-button"
          href={'#'}
          style="margin-bottom: 20px"
          id="flip_button"
          on:click|preventDefault={flip_to_reg}>
          {link_to_registration}
        </a>
        <div style="height: 25px" />

        </div>
      </div>

      <!-- App links-->
      <div style="text-align: center" class="fade-in">
        <a href={app_link_ios}>
          <img
            id="apple_store"
            style="border-radius: 10px;"
            class="mobile"
            src="/client/assets/app-store-en.png"
            alt="appstore"
            width="170"
            height="51" />
        </a>
        <a href={app_link_android}>
          <img
            id="google_store"
            style="border-radius: 10px;"
            class="mobile"
            src="/client/assets/gp-en.png"
            alt="gpplay"
            width="170"
            height="50" />
        </a>
      </div>
    </div>

    <div class="flip-card-back">
      <div style='height: auto; width: auto'>
        <div id="transition-outer" class="elem1 registerContainer mdc-elevation--z5" style='max-height: 685px;'>

        <h1 class="mdc-typography--headline5 topMargin" style="color: black;">
          {create_account_label}
        </h1>

        <div style='height: 555px;'>
          <div id="transition-private" class='slide-container'>

            <div
              id="help_liner"
              class="fade-in-long"
              style='margin-bottom: -15px'>
              <div class="tooltip-default" style="text-align: center">
                <span id="tooltip_private_merchant" class="tooltip-text tooltip-top">
                  {register_tooltip_private_merchant}
                </span>
              </div>
            </div>

            {#each unique_private as key (key)}
              <MerchantSelector
                id="merchant_selector_private"
                showed_elements={6}
                valid={validators.merchant_private}
                invalid_text={input_errors.merchant_private}
                {is_invite}
                bind:private_merchant_code
                bind:valid_private_code
                bind:value={merchant_uuid_private}
                list_state={'private'}
                bind:show_private_merchant_code_field
                bind:name={merchant_name_value_private}
                bind:items={private_merchant_selector_items}
                bind:private_id />
            {/each}

            <div id="help_line_for_private_merch" class="fade-in-long merchant-description-private" style="display: none; margin-bottom: 12px; margin-top: 0px;">
              <div class="" style="text-align: center;background: white;border-radius: 5px;-moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
              /* -webkit-box-shadow: 0 0 4px rgb(0 0 0 / 20%); *//* box-shadow: 0 0 4px rgb(0 0 0 / 20%); */">
                <span style="color: #545454; background-color: #e9e9e9; font-size: 16px;
                    text-align: center;
                    border-radius: 6px;
                    padding: 8px 8px;
                    font-size: 13px;
                    margin-top: -20px;
                    display: block;">
                  {merchant_description}
                </span>
              </div>
            </div>

            <button
              style='width: 100%; margin-top: 10px; margin-bottom: 30px;'
              class="mdc-button mdc-button--unelevated" disabled={!private_next}
              on:click|preventDefault={open_rest_of_reg}>

              <span class="mdc-button__ripple" />
              {t9n(TS.TABLE_BUTTON_NEXT)}
            </button>

            <button
              id="register_to_private_button"
              style="text-align: center"
              class="mdc-button2 mdc-dialog__button"
              on:click|preventDefault={open_country_selector}>
              <span class="mdc-button__label">{t9n(TS.REGISTER_CHANGE_TO_PRIVATE)}</span>
            </button>
          </div>

          <div id="transition-country" class='slide-container'>

            <div
              id="help_line_for_pub_merch1"
              class="fade-in-long"
              style="margin-bottom: 12px; margin-top: 0px;">
              <div class="tooltip-default" style="text-align: center">
                <span id="tooltip_public_merchant1" class="tooltip-text tooltip-top">
                  {register_tooltip_public_merchant}
                </span>
              </div>
            </div>

            <div style="margin-bottom: 16px">
              {#each unique_public as key (key)}
              <MerchantSelector
                id="merchant_selector"
                showed_elements={6}
                valid={validators.merchant}
                invalid_text={input_errors.merchant}
                {is_invite}
                bind:items={merchant_selector_items}
                bind:value={merchant_uuid}
                list_state={'public'}
                bind:name={merchant_name_value} />
                {/each}
            </div>

<!--            <p style='color: gray; font-size: 15px;'>
              you are about to register to the following service:
            </p>-->

            <div id="help_line_for_pub_merch" class="fade-in-long merchant-description" style="display: none; margin-bottom: 12px; margin-top: 0px;">
              <div class="" style="text-align: center;background: white;border-radius: 5px;-moz-box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
              /* -webkit-box-shadow: 0 0 4px rgb(0 0 0 / 20%); *//* box-shadow: 0 0 4px rgb(0 0 0 / 20%); */">
                <span style="color: #545454; background-color: #e9e9e9; font-size: 16px;
                    text-align: center;
                    border-radius: 6px;
                    padding: 8px 8px;
                    font-size: 13px;
                    margin-top: -20px;
                    display: block;">
                  {merchant_description}
                </span>
              </div>
            </div>

            <button
              id='public_merch_next'
              class="mdc-button mdc-button--unelevated" style='width: 100%; margin-top: 6px; margin-bottom: 30px;'
              disabled={!public_next} on:click|preventDefault={open_rest_of_reg}>
              <span class="mdc-button__ripple" />
              {t9n(TS.TABLE_BUTTON_NEXT)}
            </button>

            <button
              id="register_to_public_button1"
              style="text-align: center"
              class="mdc-button2 mdc-dialog__button"
              on:click|preventDefault={open_private_selector}>
              <span class="mdc-button__label">{t9n(TS.REGISTER_CHANGE_TO_PUBLIC)}</span>
            </button>

          </div>

          <div id="transition-inner" class='slide-container ' style='margin-top: -20px;'>

            <p>
              {#if valid_private_code}{merchant_name_value_private}{/if}
              {#if merchant_uuid}{merchant_name_value}{/if}
            </p>

            {#if $session.api_config}
              <div
                class="native-sel-width"
                style="width: 100%; margin-bottom: 15px;">
                <Selector
                  id="language_selector"
                  label={language_no_choice_text}
                  variant={'outlined'}
                  invalid_text={input_errors.language}
                  valid={validators.language}
                  is_required={true}
                  bind:items={language_selector_items}
                  bind:value={language} />
              </div>
            {/if}

            <!-- Email field -->
            <InputField
              autocomplete="new-email"
              id="email"
              type="email"
              label={email_label}
              leading_icon="email"
              name="email"
              is_required={true}
              bind:value={email}
              valid={validators.email}
              validation_text={input_errors.email}
              width="350px" />

            <div style="display: flex">
              <!-- First name field -->
              <div style="margin-right: 10px">
                <InputField
                  id="first-name"
                  type="text"
                  label={first_name_label}
                  name="first_name"
                  is_required={true}
                  bind:value={first_name}
                  valid={validators.first_name}
                  validation_text={input_errors.first_name}
                  width="175px" />
              </div>

              <!-- Last name field -->
              <InputField
                id="last-name"
                type="text"
                label={last_name_label}
                name="last_name"
                is_required={true}
                bind:value={last_name}
                valid={validators.last_name}
                validation_text={input_errors.last_name}
                width="auto" />

            </div>

              <!-- Phone number field -->
              <PhoneNumberField
                id="phone_number"
                error_message={input_errors.phone}
                bind:valid={validators.phone}
                bind:this={phone_field}
                bind:phone />

              <!-- Password field -->
              <div id="fade-elem" class="fadeIn">

                <InputField
                  autocomplete="new-password"
                  id="password"
                  type="password"
                  label={password_label}
                  leading_icon="security"
                  trailing_icon="password"
                  name="password"
                  is_required={true}
                  bind:value={password}
                  valid={validators.password}
                  validation_text={input_errors.password}
                  width="350px" />

                <!-- Password confirmation field -->
                <InputField
                  autocomplete="new-password"
                  id="password-confirm"
                  type="password"
                  label={confirm_password_label}
                  leading_icon="security"
                  trailing_icon="password_confirm"
                  name="password_confirm"
                  is_required={true}
                  bind:value={password_confirm}
                  valid={validators.password_confirm}
                  validation_text={input_errors.password_confirm}
                  width="350px" />
                <!-- ToU checkbox -->
                <CheckBox
                  id="accept-tou"
                  bind:value={tou_accepted}
                  label={tou_text}
                  on:change={handle_tou_change} />

                <!-- Register button -->

                <div id="action_container" class="actionContainer" style='position: relative;'>
                  <button
                    style='position: absolute; left: 0;'
                    class="mdc-button mdc-button--outlined"
                    on:click|preventDefault={handle_back}>
                    {t9n(TS.TXT_BACK)}
                  </button>
                  <button
                    data-cy="register_button"
                    class="mdc-button mdc-button--raised"
                    on:click|preventDefault={async () => { await handle_register() } }>
                    {register_label}
                  </button>
                </div>
              </div>
            </div>
        </div>

        <div style='position: relative;'>
          <div
            id="flip_back_button"
            style="margin-top: 24px; height: 10px; border-top: #ad9999;
            border-top-style: solid; border-width: thin;" />
          <a
            class="flip-button"
            id="registerButton"
            href={'#'}
            on:click|preventDefault={flip_to_login}>
            {link_to_login}
          </a>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<div class="registration-dialog" />

<!-- Forgot password dialog -->
<div id="forgotten-password-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="forgotten-password-dialog-title"
      aria-describedby="forgotten-password-dialog-content">
      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="forgotten-password-dialog-title">
        {forgotten_password_dialog_title}
      </h2>

      <div
        class="mdc-dialog__content email-padding"
        style="width: 400px;"
        id="forgotten-password-dialog-content">
        <!-- Email field -->
        <InputField
          id="forgotten-password-email"
          type="email"
          label="Email"
          leading_icon="email"
          name="forgotten-email"
          width="350px"
          bind:value={forgotten_password_email} />
      </div>

      <footer class="mdc-dialog__actions">
        <button
          id="forgotten-password-close-button"
          class="mdc-button"
          on:click|stopPropagation|preventDefault={() => forgotten_password_dialog.close()}>
          {close_button_label}
        </button>
        <!--{#if wait_api}-->
        <button
          id="forgotten-password-send-button"
          class="mdc-button mdc-button--raised"
          style="margin: 1em;"
          on:click|stopPropagation|preventDefault={async (e) => { await handle_forgotten_password(e) } }>
          {send_button_label}
        </button>
        <!--{:else}-->
        <!--  <button-->
        <!--    id='forgotten-password-send-button'-->
        <!--    class='mdc-button mdc-button&#45;&#45;raised'-->
        <!--    style='margin: 1em;'-->
        <!--    on:click|stopPropagation|preventDefault={handle_forgotten_password}>-->
        <!--    {send_button_label}-->
        <!--  </button>-->
        <!--{/if}-->

      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<!-- Resend confirmation dialog -->
<div id="resend-email-confirmation-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="resend-email-confirmation-dialog-title"
      aria-describedby="resend-email-confirmation-dialog-content">
      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="resend-email-confirmation-dialog-title">
        {resend_confirmation_label}
      </h2>

      <div
        class="mdc-dialog__content email-padding"
        style="width: 400px;"
        id="resend-email-confirmation-dialog-content">
        <!-- Email field -->
        <InputField
          id="resend-email-confirmation-input"
          type="email"
          label="Email"
          leading_icon="email"
          name="email"
          bind:value={resend_confirmation_email}
          width="350px" />
      </div>

      <footer class="mdc-dialog__actions">
        <button
          id="resend-email-confirmation-dialog-close-button"
          class="mdc-button"
          on:click|stopPropagation|preventDefault={() => resend_confirmation_dialog.close()}>
          {close_button_label}
        </button>
        <button
          id="resend-email-confirmation-dialog-send-button"
          class="mdc-button mdc-button--raised"
          style="margin: 1em;"
          on:click|stopPropagation|preventDefault={async () => { await handle_resend_confirmation() } }>
          {send_button_label}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<!--general dialog container-->
<div class="dialog" />

<style type="text/scss">
  /* Define theme variables before importing any MDC Web component styles */
  :root {
    --pageMax: 1024px;
    --translateValue: 0;
  }

  .slide-container {
    transition: all 0.3s ease-in;
    max-width: 350px;
    min-width: 110px;
    transform: translateY(var(--translateValue));
    height: 749px;
  }

  /* Flip */

  .flip-card {
    background-color: transparent;
    /*width: 440px;*/
    height: fit-content;
    /*border: 1px solid #f1f1f1; */
    perspective: 2000px; /* Remove this if you don't want the 3D effect */
    margin: auto;
  }

  @keyframes flip-anim {
    0% {
      transform: rotateY(0deg);
    }
    50% {
      transform: rotateY(90deg);
    }
    100% {
      transform: rotateY(180deg);
      display: none;
    }
  }

  .flip-button {
    text-decoration: none;
  }

  /* This container is needed to position the front and back side */
  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
    /*   transform: rotateY(0deg);*/
  }

  /*  //.flip-card:hover .flip-card-inner {
  //  transform: rotateY(180deg);
  //}

  .flip {
    //transform: rotateY(180deg);
    animation: flip-anim;
  }*/

  /* Position the front and back side */
  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
  }

  .flip-card-back {
    transform: rotateY(180deg);
  }

  /* Base */

  .body-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    margin: 0;
  }

  .contained-section {
    max-width: var(--pageMax);
    padding: 16px;
    width: calc(100vw - 32px);
    margin: 0 auto;
  }

  .main-intro .horizontal-card .demo-card__primary {
    width: calc(100% - 150px);
  }

  .mdc-button--raised {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.02),
      0px 2px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 5px 0px rgba(0, 0, 0, 0.02);
  }

  .mdc-button--raised:hover,
  .mdc-button--raised:focus {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.2), 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
  }

  .welcome-padding {
    padding-top: 40px;
  }

  .sign-margin {
    margin-top: -50px;
  }

  .margin-space {
    margin-top: 33px;
  }

  .email-padding {
    padding-top: 20px;
  }

  .confirm-center {
    text-align: center;
  }

  .check-display {
    display: inline-block;
  }

  /*Override line height on body text*/
  .mdc-typography--body2 {
    line-height: 1.8;
  }

  .mdc-button2 {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    text-decoration: none;
    text-transform: uppercase;
    padding: 0 8px 0 8px;
    display: inline-flex;
    //position: relative;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-width: 64px;
    border: none;
    outline: none;
    color: var(--mdc-theme-primary, #6200ee);
    background-color: transparent;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-appearance: none;
    overflow: visible;
    vertical-align: middle;
    cursor: pointer;
  }

  /* Style intro text*/
  .introText {
    line-height: 1.8;
    margin-left: auto;
    margin-right: auto;
    max-width: 300px;
    color: dimgray;
  }

  .logo {
    max-width: 95px;
    height: auto;
    margin-top: 5px;
  }

  /* Login Container*/
  .loginContainer {
    margin: 0 auto;
    max-width: 350px;
    text-align: center;
    padding-left: 52px;
    padding-right: 52px;
    padding-bottom: 0px;
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    height: auto;
    transition: height 2s;
    overflow: hidden;
  }

  .registerContainer {
    margin: 0 auto !important;
    max-width: 350px;
    text-align: center;
    padding: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
    height: auto;
    transition: height 2s;
    overflow: hidden;
    padding-left: 42px;
    padding-right: 42px;
  }

  /* Input */
  .mdc-text-field {
    width: 100%;
    margin-bottom: 16px;
  }

  /* Action button container */
  .actionContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
  }

  .getHelp {
    margin-right: 16px;
    color: gray;
  }

  .my-card {
    padding-top: 20px;
    padding-left: 30px;
    align-items: flex-start;
    width: 600px;
    border-radius: 10px;
  }

  /* Tooltip
 *******************************************************/

  .merchant-description::before {
    content: ' ';
    position: relative;
    top: -25px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #e9e9e9 transparent;
  }

  .merchant-description-private::before {
    content: ' ';
    position: relative;
    top: -25px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #e9e9e9 transparent;
  }

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
    display: block;
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -125px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }
</style>
